import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import th from 'vuetify/lib/locale/th';

Vue.use(Vuetify);

// สี CI ของ depa
export default new Vuetify({
  // ข้อความในตาราง/ตัวเลือกวันที่เป็นภาษาไทย (เช่น "แถวต่อหน้า" แทน "Rows per page")
  lang: {
    locales: { th },
    current: 'th',
  },
  theme: {
    themes: {
      light: {
        primary: '#0C2F53',
        secondary: '#FFC600',
        accent: '#FFF200',
      },
    },
  },
});
